import { Link } from "react-router-dom";
import { TOOLS } from "../data/tools.js";
import { track } from "../lib/track.js";

/**
 * Khối "Bước tiếp theo" dùng chung cho trang công cụ, từ điển và Playbook.
 *
 * Một nút chính nổi bật và tối đa hai liên kết phụ. Ít lựa chọn hơn giúp người
 * mới thật sự bấm tiếp, thay vì đọc ba thẻ ngang nhau rồi rời trang.
 * Gợi ý lấy từ src/data/nextSteps.js.
 */
export function giaiBuoc(steps = [], boQua = "") {
  const out = [];
  const daCo = new Set();
  for (const s of steps) {
    let item = null;
    if (s?.tool) {
      const t = TOOLS.find((x) => x.toolId === s.tool);
      if (!t || t.status !== "READY" || t.toolId === boQua) continue;
      item = { to: `/cong-cu/${t.slug}`, label: s.label || t.title, moTa: s.moTa || t.blurb, id: t.toolId };
    } else if (s?.to && s?.label) {
      item = { to: s.to, label: s.label, moTa: s.moTa || "", id: s.to };
    }
    if (item && !daCo.has(item.to)) {
      daCo.add(item.to);
      out.push(item);
    }
    if (out.length === 3) break;
  }
  return out;
}

export default function NextStep({ steps, nguon, boQua, tieuDe = "Bước tiếp theo của bạn", children }) {
  const list = giaiBuoc(steps, boQua);
  if (!list.length) return null;
  const [chinh, ...phu] = list;
  const ghi = (s) => () => track("next_step_click", { tool: nguon, target: s.id });
  return (
    <section className="buoc-tiep surface" aria-labelledby="buoc-tiep-tieu-de">
      <p className="eyebrow">TIẾP TỤC CHUẨN BỊ</p>
      <h2 id="buoc-tiep-tieu-de">{tieuDe}</h2>
      <div className="buoc-tiep-chinh">
        <Link className="nut" to={chinh.to} onClick={ghi(chinh)}>
          {chinh.label} →
        </Link>
        {chinh.moTa && <p className="muted">{chinh.moTa}</p>}
      </div>
      {phu.length > 0 && (
        <p className="buoc-tiep-phu">
          Hoặc:{" "}
          {phu.map((s, i) => (
            <span key={s.to}>
              {i > 0 && " hoặc "}
              <Link to={s.to} onClick={ghi(s)}>
                {s.label}
              </Link>
            </span>
          ))}
        </p>
      )}
      {children}
    </section>
  );
}
